<app-login-layout [questions]="'patient'">
  <div
    class="page-wrapper"
        [ngStyle]="{
            backgroundImage:
                'url(' + (backgroundImg$ | async).backgroundImage + ')'
        }"
    >
    <div class="content-wrapper">
      <div class="option-card"
        [class.identical-login-ui]="identicalLoginUiStyle$ | async">
        <form
          [formGroup]="tanLoginForm"
          (ngSubmit)="onSubmit()"
          role="form"
          >
          <div class="option-card-body">
            <div class="option-card-header">
              <h3 class="form-signin-heading option-card-heading">
                {{ "LOGIN.TAN-TITLE" | translate }}
              </h3>
              <span class="option-card-subtitle weight-300">{{
                "LOGIN.TAN-SUBTITLE" | translate
              }}</span>
            </div>
            <fieldset class="tan-input-group">
              <legend class="sr-only">
                {{ "LOGIN.TAN_CODE_ENTRY" | translate }}
              </legend>

              <!-- BFSG: Live region for TAN input progress -->
              <div
                class="sr-only"
                aria-live="polite"
                aria-atomic="true"
                id="tan-progress-announcer"
              ></div>

              <!-- BFSG: Instructions for screen readers -->
              <div class="sr-only" id="tan-instructions">
                {{
                "ACCESSIBILITY.TAN_INPUT_INSTRUCTIONS"
                | translate
                }}
              </div>

              <div
                class="tan-input-line"
                role="group"
                                [attr.aria-label]="
                                    'LOGIN.TAN_CODE_INSTRUCTIONS' | translate
                                "
                [attr.aria-describedby]="'tan-instructions'"
                >
                <input
                  type="text"
                  #code1
                  id="code1"
                  name="code1"
                  formControlName="code1"
                  class="tan-input"
                  size="1"
                  maxlength="1"
                  autocomplete="one-time-code"
                  inputmode="text"
                  pattern="[0-9A-Za-z]"
                                    [attr.aria-label]="
                                        'LOGIN.TAN_DIGIT_1' | translate
                                    "
                                    [attr.aria-describedby]="
                                        'tan-instructions tan-progress-announcer'
                                    "
                  aria-required="true"
                                    [attr.aria-invalid]="
                                        tanLoginForm.get('code1')?.invalid &&
                                        tanLoginForm.get('code1')?.touched
                                    "
                  [attr.aria-posinset]="1"
                  [attr.aria-setsize]="6"
                  (keyup.backspace)="handleBackspace($event)"
                  (keyup.arrowRight)="goToNextInput($event)"
                  (input)="handleInput($event)"
                  (focus)="handleFocus($event)"
                  (paste)="onPaste($event)"
                  />
                <input
                  type="text"
                  #code2
                  id="code2"
                  name="code2"
                  formControlName="code2"
                  class="tan-input"
                  size="1"
                  maxlength="1"
                  autocomplete="one-time-code"
                  inputmode="text"
                  pattern="[0-9A-Za-z]"
                                    [attr.aria-label]="
                                        'LOGIN.TAN_DIGIT_2' | translate
                                    "
                                    [attr.aria-describedby]="
                                        'tan-instructions tan-progress-announcer'
                                    "
                  aria-required="true"
                                    [attr.aria-invalid]="
                                        tanLoginForm.get('code2')?.invalid &&
                                        tanLoginForm.get('code2')?.touched
                                    "
                  [attr.aria-posinset]="2"
                  [attr.aria-setsize]="6"
                  (keyup.backspace)="handleBackspace($event)"
                  (keyup.arrowRight)="goToNextInput($event)"
                                    (keyup.arrowLeft)="
                                        goToPreviousInput($event)
                                    "
                  (input)="handleInput($event)"
                  (focus)="handleFocus($event)"
                  (paste)="onPaste($event)"
                  />
                <input
                  type="text"
                  #code3
                  id="code3"
                  name="code3"
                  formControlName="code3"
                  class="tan-input"
                  size="1"
                  maxlength="1"
                  autocomplete="one-time-code"
                  inputmode="text"
                  pattern="[0-9A-Za-z]"
                                    [attr.aria-label]="
                                        'LOGIN.TAN_DIGIT_3' | translate
                                    "
                                    [attr.aria-describedby]="
                                        'tan-instructions tan-progress-announcer'
                                    "
                  aria-required="true"
                                    [attr.aria-invalid]="
                                        tanLoginForm.get('code3')?.invalid &&
                                        tanLoginForm.get('code3')?.touched
                                    "
                  [attr.aria-posinset]="3"
                  [attr.aria-setsize]="6"
                  (keyup.backspace)="handleBackspace($event)"
                  (keyup.arrowRight)="goToNextInput($event)"
                                    (keyup.arrowLeft)="
                                        goToPreviousInput($event)
                                    "
                  (input)="handleInput($event)"
                  (focus)="handleFocus($event)"
                  (paste)="onPaste($event)"
                  />
                <input
                  type="text"
                  #code4
                  id="code4"
                  name="code4"
                  formControlName="code4"
                  class="tan-input"
                  size="1"
                  maxlength="1"
                  autocomplete="one-time-code"
                  inputmode="text"
                  pattern="[0-9A-Za-z]"
                                    [attr.aria-label]="
                                        'LOGIN.TAN_DIGIT_4' | translate
                                    "
                                    [attr.aria-describedby]="
                                        'tan-instructions tan-progress-announcer'
                                    "
                  aria-required="true"
                                    [attr.aria-invalid]="
                                        tanLoginForm.get('code4')?.invalid &&
                                        tanLoginForm.get('code4')?.touched
                                    "
                  [attr.aria-posinset]="4"
                  [attr.aria-setsize]="6"
                  (keyup.backspace)="handleBackspace($event)"
                  (keyup.arrowRight)="goToNextInput($event)"
                                    (keyup.arrowLeft)="
                                        goToPreviousInput($event)
                                    "
                  (input)="handleInput($event)"
                  (focus)="handleFocus($event)"
                  (paste)="onPaste($event)"
                  />
                <input
                  type="text"
                  #code5
                  id="code5"
                  name="code5"
                  formControlName="code5"
                  class="tan-input"
                  size="1"
                  maxlength="1"
                  autocomplete="one-time-code"
                  inputmode="text"
                  pattern="[0-9A-Za-z]"
                                    [attr.aria-label]="
                                        'LOGIN.TAN_DIGIT_5' | translate
                                    "
                                    [attr.aria-describedby]="
                                        'tan-instructions tan-progress-announcer'
                                    "
                  aria-required="true"
                                    [attr.aria-invalid]="
                                        tanLoginForm.get('code5')?.invalid &&
                                        tanLoginForm.get('code5')?.touched
                                    "
                  [attr.aria-posinset]="5"
                  [attr.aria-setsize]="6"
                  (keyup.backspace)="handleBackspace($event)"
                  (keyup.arrowRight)="goToNextInput($event)"
                                    (keyup.arrowLeft)="
                                        goToPreviousInput($event)
                                    "
                  (input)="handleInput($event)"
                  (focus)="handleFocus($event)"
                  (paste)="onPaste($event)"
                  />
                <input
                  type="text"
                  #code6
                  id="code6"
                  name="code6"
                  formControlName="code6"
                  class="tan-input"
                  size="1"
                  maxlength="1"
                  autocomplete="one-time-code"
                  inputmode="text"
                  pattern="[0-9A-Za-z]"
                                    [attr.aria-label]="
                                        'LOGIN.TAN_DIGIT_6' | translate
                                    "
                                    [attr.aria-describedby]="
                                        'tan-instructions tan-progress-announcer'
                                    "
                  aria-required="true"
                                    [attr.aria-invalid]="
                                        tanLoginForm.get('code6')?.invalid &&
                                        tanLoginForm.get('code6')?.touched
                                    "
                  [attr.aria-posinset]="6"
                  [attr.aria-setsize]="6"
                  (keyup.backspace)="handleBackspace($event)"
                  (keyup.arrowRight)="goToNextInput($event)"
                                    (keyup.arrowLeft)="
                                        goToPreviousInput($event)
                                    "
                  (input)="handleInput($event)"
                  (focus)="handleFocus($event)"
                  (paste)="onPaste($event)"
                  />
              </div>
            </fieldset>
            <div
              class="checkbox agb-and-security-check"
              [hidden]="hideDataProcessTerms$ | async"
              >
              <div class="checkbox-wrapper outlined-checkbox">
                <input
                  type="checkbox"
                  #dataProcessTerm
                  id="data-process-term"
                  name="dataProcessTerm"
                  formControlName="dataProcessTerm"
                                    ngbTooltip="{{
                                        'GENERAL.ERROR.DATA-PROCESS-TERM'
                                            | translate
                                    }}"
                  placement="bottom"
                  triggers="manual"
                  appInvalidDirective
                  />
              </div>
              <label for="data-process-term">
                <span>
                  {{
                  "GENERAL.DATA-PROCESS-TERM-PREFIX"
                  | translate
                  }}
                  <a
                    [routerLink]="dataProcessTermsRoute"
                    target="_blank"
                    >
                    {{
                    "GENERAL.DATA-PROCESS-TERM-LINKNAME"
                    | translate
                    }}</a
                    >
                    {{
                    "GENERAL.DATA-PROCESS-TERM-POSTFIX"
                    | translate
                    }}
                  </span>
                </label>
              </div>
              <div
                class="checkbox agb-and-security-check"
                [hidden]="removeAgbCheckbox$ | async"
                >
                <div class="checkbox-wrapper outlined-checkbox">
                  <input
                    type="checkbox"
                    #agbTerm
                    id="term-agb"
                    name="agbTerm"
                    formControlName="agbTerm"
                                    ngbTooltip="{{
                                        'GENERAL.ERROR.AGB' | translate
                                    }}"
                    placement="bottom"
                    triggers="manual"
                    appInvalidDirective
                    />
                </div>
                <label
                  for="term-agb"
                  class="data-process-agreement"
                  >
                  <span>
                    {{ "LOGIN.TAN-ACCEPT-PREFIX" | translate }}
                    <a
                      target="_blank"
                      [routerLink]="termsRoute"
                      >
                      {{ "LOGIN.TAN-AGB" | translate }}</a
                      >
                      {{ "LOGIN.TAN-ACCEPT-MIDFIX" | translate }}
                      <a
                        target="_blank"
                        [routerLink]="dataSecurityRoute"
                        >
                        {{
                        "LOGIN.TAN-DATASECURITY" | translate
                        }}</a
                        >
                        {{ "LOGIN.TAN-ACCEPT-POSTFIX" | translate }}
                      </span>
                    </label>
                  </div>
                </div>
                @if (tanLoginForm.hasError('notValid')) {
                  <div
                    class="error-message"
                    role="alert"
                    aria-live="assertive"
                    >
                    {{ "LOGIN.TAN-ERROR" | translate }}
                  </div>
                }
                @if (tanLoginForm.hasError('rateLimitReached')) {
                  <div
                    class="error-message"
                    role="alert"
                    aria-live="assertive"
                    >
                    <i
                      class="fas fa-exclamation-triangle"
                      aria-hidden="true"
                    ></i>
                    {{ "LOGIN.TAN-ERROR-RATE-LIMIT" | translate }}
                  </div>
                }
                <div class="option-card-footer flex-to-side">
                  <button
                    class="button"
                    type="submit"
                    id="TAN-form-submit"
                    [disabled]="tanLoginForm.invalid"
                    [attr.aria-disabled]="tanLoginForm.invalid"
                            [attr.aria-describedby]="
                                tanLoginForm.invalid ? 'tan-form-errors' : null
                            "
                            [ngClass]="
                            (identicalLoginUiStyle$ | async) ? 'dark-blue' : 'btn-secondary'
                            "
                    >
                    {{ "LOGIN.BUTTON" | translate }}
                    <i
                      class="fal fa-check-circle"
                      aria-hidden="true"
                    ></i>
                  </button>
                </div>
              </form>
            </div>
            @if (!(brandingData$ | async)?.removeDoctorLink) {
              <div
                class="further-links-section"
                >
                <span>
                  {{ "LOGIN.YOU-ARE-DOCTOR" | translate }}
                  <a routerLink="/{{ doctorLoginRoute }}" class="link-dark">{{
                    "LOGIN.DOCTOR-LOGIN-LINK" | translate
                  }}</a>
                </span>
              </div>
            }
            <!-- Proposal (OVS-2563, Slack feedback): browser hint out of the form flow -->
            <app-browser-info></app-browser-info>
          </div>
        </div>
      </app-login-layout>
